import type { AcqRateKind } from "~domain/devices/models/acq-rate-model.ts";
import type { MODULATOR_ACQ_RATE_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/modulator-acq-rate-card/modulator-acq-rate-card.fr.ts";

const acqRateKind: Record<AcqRateKind, string> = {
  DAY: "24 hours",
  WEEK: "7 days",
  MONTH: "30 days",
};

export const MODULATOR_ACQ_RATE_CARD_ENGLISH_LOCALE = {
  title: "Acquisition rate",
  acqRateKind: acqRateKind,
} satisfies typeof MODULATOR_ACQ_RATE_CARD_FRENCH_LOCALE;
